module.exports = __webpack_public_path__ + "img/12.32be8127.jpeg";